import { cn } from '@/lib/utils';
import { motion } from 'motion/react';

const EnterTransition = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{
        duration: 0.2,
        ease: 'easeOut',
      }}
      className={cn('h-full', className)}
    >
      {children}
    </motion.div>
  );
};

export { EnterTransition };
